import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartItems,
  getProductCategoryList,
  getProductList,
} from "../../actions/cartAction";
import BreadCrumb from "../../components/Breadcrumb";
import StoreItem from "../../components/StoreItem";
const Store = () => {
  const productList = useSelector((state) => state.cart.productList);
  const categoryList = useSelector((state) => state.cart.categoryList);
  const [searchText, setSearchText] = useState("");
  const [searchId, setSearchId] = useState(0);
  const [categoryId, setCategoryId] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  const handleSelectClick = (id = 0) => {
    let filterData = productList.filter((x) =>
      x.name.toLowerCase().includes(searchText.toLowerCase())
    );
    if (categoryId > 0) {
      filterData = filterData.filter((x) => x.categoryId == categoryId);
    }
    switch (parseInt(id)) {
      case 1:
        filterData.sort((a, b) =>
          parseFloat(a.price) > parseFloat(b.price) ? 1 : -1
        );
        break;
      case 2:
        filterData.sort((a, b) =>
          parseFloat(a.price) < parseFloat(b.price) ? 1 : -1
        );
        break;
      case 3:
        filterData.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 4:
        let acc = filterData.sort((a, b) => a.name.localeCompare(b.name));
        filterData = acc.reverse();
        break;
      default:
        break;
    }
    setFilteredData(filterData);
  };
  const handleSearchClick = () => {
    let filterData = productList.filter((x) =>
      x.name.toLowerCase().includes(searchText.toLowerCase())
    );

    if (categoryId > 0) {
      filterData = filterData.filter((x) => x.categoryId == categoryId);
    }
    switch (parseInt(searchId)) {
      case 1:
        filterData.sort((a, b) =>
          parseFloat(a.price) > parseFloat(b.price) ? 1 : -1
        );
        break;
      case 2:
        filterData.sort((a, b) =>
          parseFloat(a.price) < parseFloat(b.price) ? 1 : -1
        );
        break;
      case 3:
        filterData.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 4:
        let acc = filterData.sort((a, b) => a.name.localeCompare(b.name));
        filterData = acc.reverse();
        break;
      default:
        break;
    }
    setFilteredData(filterData);
  };

  const handleCategoryClick = (id) => {
    let filterData = productList.filter((x) =>
      x.name.toLowerCase().includes(searchText.toLowerCase())
    );
    if (id > 0) {
      filterData = filterData.filter((x) => x.categoryId == id);
    }
    switch (parseInt(searchId)) {
      case 1:
        filterData.sort((a, b) =>
          parseFloat(a.price) > parseFloat(b.price) ? 1 : -1
        );
        break;
      case 2:
        filterData.sort((a, b) =>
          parseFloat(a.price) < parseFloat(b.price) ? 1 : -1
        );
        break;
      case 3:
        filterData.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 4:
        let acc = filterData.sort((a, b) => a.name.localeCompare(b.name));
        filterData = acc.reverse();
        break;
      default:
        break;
    }
    setFilteredData(filterData);
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getProductList(() => {
        setIsLoading(false);
      })
    );
    dispatch(getCartItems(role.val));
    dispatch(getProductCategoryList());
  }, []);

  useEffect(() => {
    setFilteredData(productList);
  }, [productList]);
  return (
    <div className="store-page">
      <BreadCrumb pageName="Store" />
      <div className="row">
        <div className="col-sm-6">
          <h3 className="page-title">Store</h3>
          <p className="page-desc">View our products and add to cart.</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8">
          <div className="filter-section">
            <div className="search-bar">
              <p>Search:</p>
              <input
                placeholder="I'm searching for..."
                onChange={(e) => setSearchText(e.target.value)}
              />
              <button onClick={handleSearchClick}>
                {" "}
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
            <div className="sort-section">
              <p>Category:</p>
              <select
                className="dropdown"
                onChange={(e) => {
                  setCategoryId(e.target.value);
                  handleCategoryClick(e.target.value);
                }}
              >
                <option value={0}>All</option>
                {categoryList.map((x) => (
                  <option key={x.categoryId} value={x.categoryId}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="sort-section">
              <p>Sort By:</p>
              <select
                className="dropdown"
                onChange={(e) => {
                  setSearchId(e.target.value);
                  handleSelectClick(e.target.value);
                }}
              >
                <option value={0}>All</option>
                <option value={1}>Price low to high</option>
                <option value={2}>Price high to low</option>
                <option value={3}>Name A to Z</option>
                <option value={4}>Name Z to A</option>
              </select>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          {isLoading ? (
            <>
              <ContentLoader viewBox="0 0 400 400" height={400} width={400}>
                <rect x="16" y="17" rx="0" ry="0" width="360" height="200" />
                <rect x="69" y="229" rx="2" ry="2" width="275" height="15" />
                <rect x="69" y="253" rx="2" ry="2" width="140" height="15" />
              </ContentLoader>
              <ContentLoader viewBox="0 0 400 400" height={400} width={400}>
                <rect x="16" y="17" rx="0" ry="0" width="360" height="200" />
                <rect x="69" y="229" rx="2" ry="2" width="275" height="15" />
                <rect x="69" y="253" rx="2" ry="2" width="140" height="15" />
              </ContentLoader>
              <ContentLoader viewBox="0 0 400 400" height={400} width={400}>
                <rect x="16" y="17" rx="0" ry="0" width="360" height="200" />
                <rect x="69" y="229" rx="2" ry="2" width="275" height="15" />
                <rect x="69" y="253" rx="2" ry="2" width="140" height="15" />
              </ContentLoader>
            </>
          ) : (
            <>
              {filteredData.length > 0 ? (
                <div className="grid-container">
                  {filteredData.map((x) => (
                    <StoreItem
                      key={x.productId}
                      category={x.category}
                      name={x.name}
                      description={x.description}
                      price={(x.price / 100).toFixed(2)}
                      image={x.imageUrl}
                      productId={x.productId}
                      quantity={x.quantity}
                    />
                  ))}
                </div>
              ) : (
                <div className="no-item">
                  <h1>Sorry, No product found</h1>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Store;
